require('lang');

// CSS
require("def.css");
require("css/global.css");
require("ui.dynatree.css");
require("ui-lightness/jquery-ui-1.8.24.custom.css");
require("editor_rewrite.css");
require("opentip.css");
require("css/flexboxgrid.min.css");
require("css/flags.css");
require("css/font-awesome.css");
require("css/semantic-components.css");
require("css/cropper.min.css");
require("css/select-pure.css");
require('js/datetimepicker/jquery.simple-dtpicker.css')


// JS
require('script-loader!js/jquery-3.6.0');
require('script-loader!js/jquery-ui.1.13.2.min');
require('script-loader!js/jquery.blockUI');
require('script-loader!js/jquery.tinyscrollbar.min');
require('script-loader!js/jquery.dynatree');
require('script-loader!js/jquery.simplemodal.1.4.4');
require('script-loader!js/jquery_form');
require('script-loader!js/jquery.tokeninput');
require('script-loader!js/jquery.dragsort.min');
require('script-loader!js/datetimepicker/jquery.simple-dtpicker');
require('script-loader!js/ajaxupload.3.5');
require('script-loader!js/global');
require('script-loader!js/def');
require('script-loader!js/taskspopup');
require('script-loader!js/opentip-jquery');
require('script-loader!js/marionette/underscore');
require('script-loader!js/document_user_addresses');
require('script-loader!js/cropper.min');
require('script-loader!js/select-pure');
require('script-loader!js/jquery-migrate-1.4.1');
